export default {
    general: {
        invalid_password: 'סיסמה חייבת להיות בת 8 תוים לפחות',
        invalid_verify_password: 'הסיסמה לא תואמת את שדה הסיסמה הראשון',
    },
    signup: {
        password: 'סיסמה',
        verify_password: 'וודא סיסמה',
        email: 'כתובת דוא"ל',
        send_request: 'שלח בקשה',
        title: 'הרשמה למערכת',
        error: 'שגיאה',
        email_taken: 'כתובת המייל נמצאת בשימוש',
        on_request_confirmed:
            'עם אישור הבקשה על ידי מנהלי האתר, ישלח אליך מייל להשלמת תהליך ההרשמה.',
        request_sent: 'בקשת ההרשמה לאתר נשלחה בהצלחה!',
        error_first_name: 'שם פרטי לא תקין',
        error_last_name: 'שם משפחה לא תקין',
        error_id: 'ת״ז לא תקינה',
        error_instructor: 'סוג מדריך לא תקין',
        error_cell_num: 'מס׳ נייד לא תקין',
        error_phone: 'מס׳ טלפון לא תקין',
        error_address: 'כתובת לא תקינה',
        error_email: 'דוא״ל לא תקין',
        error_password: 'סיסמה לא תקינה',
        error_verify_password: 'אישור סיסמה לא תקין',
    },
    forgot_password: {
        email: 'כתובת דוא"ל',
        title: 'שכחתי סיסמה',
        send: 'שלח',
        error: 'שגיאה',
        description: 'מלא את כתובת האימייל איתה נרשמת ולחץ שלח',
        unvalid_email: 'אימייל לא תקין',
        email_not_found: 'כתובת המייל לא נמצאה במערכת',
        email_sent: 'שלחנו לך אימייל לאיפוס סיסמה',
        check_email: 'אנא בדוק את תיבת האימייל שלך',
    },
    login: {
        log_in_if_registered: 'התחברות למערכת (למשתמשים קיימים)',
        dont_have_account: 'אין לך חשבון עדיין? לחץ',
        to_sign_up: 'כדי להרשם',
        email: 'דוא״ל',
        password: 'סיסמה',
        log_in: 'התחברות',
        log_in_failed: 'ההתחברות נכשלה',
        default_error: 'ארעה שגיאה',
        wrong_password: 'סיסמה שגויה',
        no_existing_email:
            'לא נמצא משתמש רשום עם כתובת אימייל זו, או שטרם אושרה בקשת ההרשמה על ידי מנהלי המערכת',
        user_blocked: 'משתמש חסום. אנא פנה למנהלי האתר',
        here: 'כאן',
        forgot_password: 'שכחתי סיסמה',
        login_restricted_to_members: 'לחברי ארגון המדריכים בלבד',
        not_signed_yet: 'עדיין לא רשומים לאתר?',
        signup_here: 'הירשמו פה',
    },
    profile: {
        headline: 'פרופיל',
        first_name: 'שם פרטי',
        last_name: 'שם משפחה',
        email: 'דואר אלקטרוני',
        id: 'תעודת זהות',
        cell_number: 'מס׳ סלולרי',
        another_phone: 'טלפון נוסף',
        address: 'כתובת',
        instructor_type: 'סוג משתמש',
        membership_number: 'מס׳ חבר',
        select: 'בחר/י',
        max_parallel_orders: 'מקסימום הזמנות במקביל',
    },
    user_menu_headlines: {
        main_page: 'ראשי',
        contact_us: 'צור קשר',
        profile: 'פרופיל',
        logout: 'התנתק',
    },
    edit_user: {
        first_name: 'שם פרטי',
        last_name: 'שם משפחה',
        email: 'דואר אלקטרוני',
        id: 'תעודת זהות',
        cell_number: 'מס׳ סלולרי',
        another_phone: 'טלפון נוסף',
        address: 'כתובת',
        instructor_type: 'סוג משתמש',
        membership_number: 'מס׳ חבר',
        max_parallel_orders: 'מקסימום הזמנות במקביל',
        membership_paid: 'שילם חברות',
        admin: 'מנהל',
        headline: 'עריכת פרטי משתמש',
        save_button: 'שמור',
        cancel_button: 'ביטול',
        save_changes_modal_headline: 'שמירת שינויים',
        save_changes_modal_content: 'האם אתה בטוח שברצונך לשמור את השינויים?',
        changes_succussfully_saved_modal_title: 'השינויים נשמרו בהצלחה',
        changes_succussfully_saved_modal_content: '',
        yes: 'כן',
        no: 'לא',
    },
    table: {
        show_more_details: 'הצג פרטים נוספים',
        show_less_details: 'הסתר פרטים',
        presenting_results: 'מציג תוצאות',
        out_of: 'מתוך',
        search: 'חיפוש',
        export: 'ייצא רשימת',
    },
    dances_table: {
        dance_name: 'שם ריקוד',
        status: 'סטטוס',
        choreographer: 'מחבר',
        style: 'סוג ריקוד',
        performer: 'שם מבצע',
        composer: 'שם מלחין',
        lyricist: 'שם משורר',
        approval_date: 'תאריך אישור הזמנה',
        request_date: 'תאריך הזמנה',
        akum_id: 'מס׳ יצירה אקו״ם',
        edit: 'עריכה',
        user_details: 'פרטי המשתמש',
    },
    dances_table_filters: {
        dances_title: 'ריקודים',
        status: 'סטטוס ריקוד',
        choreographer: 'שם מחבר',
        style: 'סוג ריקוד',
        performer: 'מבצע',
        composer: 'מלחין',
        lyricist: 'משורר',
    },
    dances_expanded_row: {
        original_name: 'שם יצירה מקורי',
        co_choreographers: 'מחברים נוספים',
        request_date: 'תאריך הזמנה',
        approval_date: 'תאריך אישור הזמנה',
        completion_date: 'שנת ריקוד',
        notes: 'הערות',
        link_to_lyrics: 'קישור למילות השיר',
        link_to_original_song: 'וידאו שיר מקורי',
        link_to_dance_video: 'סרטון ריקוד',
    },
    users_table: {
        first_name: 'שם פרטי',
        last_name: 'שם משפחה',
        status: 'סטטוס',
        ordered: 'מוזמנים',
        confirmed: 'מאושרים',
        exists: 'קיימים',
        max_parallel_orders: 'מקס׳ הז׳ במקביל',
        admin: 'מנהל',
        dances: 'ריקודים',
        edit: 'עריכה',
    },
    users_table_filters: {
        users_title: 'משתמשים',
        search: 'חיפוש משתמשים',
        choreographer_type: 'סוג משתמש',
        status: 'סטטוס',
        max_parallel_orders: 'מספר הזמנות מקסימלי',
    },
    users_expanded_row: {
        cell: 'מס׳ סלולרי',
        another_phone: 'טלפון נוסף',
        address: 'כתובת',
        member_id: 'מס׳ חבר',
        choreographer_type: 'סוג משתמש',
        email: 'דואר אלקטרוני',
    },
    logs_table: {
        action: 'סוג פעולה',
        created: 'תאריך',
        user_name: 'משתמש מבצע',
        user_email: 'אימייל מ.מבצע',
        user_is_admin: 'סוג מ.מבצע',
        dance_name: 'שם ריקוד',
        target_user_name: 'משתמש מטרה',
        target_user_email: 'אימייל משתמש מטרה',
        description: 'תיאור',
        target_group: 'נמענים',
    },
    logs_table_filters: {
        logs_title: 'פעולות מערכת',
        search: 'חיפוש',
        action_type: 'סוג פעולה',
        choreographer_name: 'שם משתמש מבצע',
        user_type: 'סוג משתמש מבצע',
        from_date: 'מתאריך',
        to_date: 'עד תאריך',
    },
    settings_headers: {
        email_distributor: 'עורך הפצת אימיילים',
        email_editor: 'עריכת אימיילים',
        general: 'הגדרות כלליות',
        users_log: 'לוג משתמשים',
    },
    buttons: {
        add_new_dance: 'רישום שיר חדש',
        pay_membership: 'תשלום דמי חבר',
        to_year: 'לשנת',
        remaining: 'עוד',
        songs: 'שירים',
    },
    edit_dance: {
        ordered_by: 'מוזמן ע״י',
        song_name: 'שם שיר',
        status: 'סטטוס',
        edit_dance: 'עריכת ריקוד',
        add_dance: 'רישום ריקוד',
        select: 'בחר/י',
        dance_style: 'סוג הריקוד',
        co_choreographers: 'מחברים נוספים',
        order_date_and_time: 'תאריך ושעת הזמנה',
        compeletion_date: 'תאריך סיום',
        link_to_dance: 'קישור לסרטון הריקוד',
        link_to_song: 'קישור לסרטון שיר',
        link_to_lyrics: 'לינק למילות השיר',
        notes: 'הערות',
        additional_info:
            'במידה ובקשת רישום הריקוד תאושר, תדרשו להוסיף קישור לסרטון הריקוד על מנת להפוך את בקשתכם לריקוד קיים.',
        minimum_search_length_error: 'עליך להכניס טקסט עם לפחות 3 תווים',
        search_song_in_akum: 'חיפוש שיר באקו״ם',
        canael_order: 'ביטול הזמנה',
        cancel_edit: 'ביטול עריכה',
        dance_name_changeable: 'שם ריקוד (ניתן לשינוי)',
        perform_new_akum_search: 'בצע חיפוש חדש באקו״ם',
        original_song_name: 'שם שיר מקורי',
        akum_id: 'מספר יצירה באקו״ם',
        translated_version_id: 'מספר יצירה מקורית',
        song_publication_year: 'שנת פרסום שיר',
        performer: 'שם מבצע',
        composer: 'שם מלחין',
        lyricist: 'שם משורר',
        approval_date: 'תאריך אישור הזמנה',
        manual_registration_request: 'אנא מלא את פרטי השיר ידנית, או',
        perform_new_search: 'בצע חיפוש שיר באקום מחדש',
        required_fields: 'שדות חובה',
        no_akum_search_error: 'טרם בוצע חיפוש שיר באקו״ם',
        save: 'שמור',
        send_request: 'שלח בקשה',
        delete_dance: 'מחק ריקוד',
        reject_dance: 'דחה ריקוד',
        confirm_delete_dance: 'האם אתה בטוח שברצונך למחוק את הריקוד?',
        confirm_reject_dance: 'האם אתה בטוח שברצונך לדחות את הריקוד?',
        confirm_request: 'אישור הזמנה',
        confirm_confirm_request: 'האם אתה בטוח שברצונך לאשר את הזמנת הריקוד?',
        make_dance_exist: 'הפוך לריקוד קיים',
        confirm_make_dance_exist:
            'האם אתה בטוח שברצונך לאשר את הריקוד ולהפוך אותו לריקוד קיים?',
        reject_reason: 'סיבת הדחיה',
        delete_reason: 'סיבת המחיקה',
        confirm_reason: 'סיבת האישור',
        input_missing: 'אחד (או יותר) משדות החובה ריקים',
    },
    modals: {
        confirm: 'אישור',
        error: 'שגיאה',
        dance_updated_successfully: 'הריקוד התעדכן בהצלחה',
        back_to_dances_screen: 'חזרה לעמוד הריקודים',
        request_recieved: 'בקשתך התקבלה!',
        request_under_review: 'מנהלי המערכת בוחנים את בקשתך ויעדכנו בהקדם',
        video_url_empty: 'שדה קישור לסרטון הריקוד ריק',
        video_url_empty_description:
            'לא ניתן להפוך לריקוד קיים בלי קישור לסרטון הריקוד',
    },
    akum_results_table: {
        back_to_add_dance: 'חזרה לעמוד רישום ריקוד',
        search_of_song: 'חיפוש השיר',
        in_the_database_of: 'במאגר המידע של אקו״ם',
        cant_find_the_song: 'לא מוצא את השיר?',
        fill_song_manualy: 'ומלא את פרטי השיר ידנית',
        work_name: 'שם יצירה',
        work_id: 'מס יצירה',
        composer: 'מלחין',
        lyricist: 'משורר',
        performer: 'מבצע',
        show_versions: 'הצג גרסאות',
        choose_version: 'בחר גרסה',
        musical_versions: 'יצירות/גרסות מוזיקליות',
        translated_versions: 'יצירות מתורגמות',
        songs: 'שירים',
        filter_by_performer: 'סנן לפי שם מבצע',
        search_song_and_performer: 'חיפוש שיר ומבצע באקו״ם',
        minimum_search_length_error: 'עליך להכניס טקסט עם לפחות 3 תווים',
        version_search_for_song: 'חיפוש גירסה לשיר',
        cant_find_the_version: 'לא מוצא את הגרסה?',
        and_go_back_to_songs_screen: 'וחזור לעמוד השירים',
        version_number: 'גרסה מס׳',
        publication_date: 'תאריך פרסום',
        dance_alreay_exists: 'הריקוד כבר קיים במערכת',
        click_here: 'לחץ כאן',
    },
    headers: {
        dances: 'ריקודים',
        my_dances: 'הריקודים שלי',
        users: 'משתמשים',
        settings: 'הגדרות',
        hello: 'שלום',
    },
}
